//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const POST_LOGIN = "/auth"
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//dashboard
export const DASHBOARD_URL = "/dashboard"
export const DASHBOARD_SCHEDULED_URL = "/dashboard/scheduled"
export const DASHBOARD_LIVE_URL = "/dashboard/live"

//Zoom
export const ZOOM_AUTH_URL = "/zoomauth"
export const ZOOM_UPDATE_TOKEN_URL = "/zoomauth/update-token"

//Documents
export const DOCUMENT_URL = "/document"
export const DOWNLOAD_ARTIFACT_ATTACHMENT_URL = "/document/download"

//Navigation
export const NAVIGATION_URL = "/navigation"

//Staff
export const USER_URL = "/users"
export const ADD_NEW_USER = "/users/saveuser"

//ROLES
export const ROLE_URL = "/roles"
export const ROLE_TYPES_URL = "/roles/types"

//Photo
export const PHOTO_URL = "/upload"

/*Common helper functions */
export const GET_PERMISSION_TYPES_URL = "/helper/permissiontypes"
export const GET_NOTIFICATION_EVENTS_URL = "/helper/notificationevents"
export const GET_NOTIFICATION_RECIPIENTS_URL = "/helper/notificationrecipients"
export const GET_PRIVACY_TYPES_URL = "/helper/privacytypes"
export const PAYMENT_METHOD_URL = "/helper/paymentmethods"
export const COUNTRY_URL = "/helper/countries"
export const STATE_URL = "/helper/states"
export const CITY_URL = "/helper/cities"
export const AVAILABLE_TYPES_URL = "/helper/availabletypes"
export const SERVICES_URL = "/helper/services"
export const AVAILABILITIES_URL = "/helper/availabilities"
export const SPECIALIZATIONS_URL = "/helper/specializations"
export const MEETING_START_URL = "/helper/meetingstarturl"

//Staff Availability
export const USER_AVAILABILITY_URL = "/availabilities"

//Staff Profile
export const USER_PROFILE_URL = "/users/profile"

//Notifications
export const NOTIFICATION_URL = "/notifications"
export const ADD_NEW_NOTIFICATION = "/notifications/savenotification"

export const GET_GENDER_URL = "/helper/genders"

//Center Profile
export const CENTER_PROFILE_URL = "/centerprofile"
export const CENTER_PROFILE_UPDATE_URL = "/centerprofile/center"
export const CENTER_PROFILE_ADDRESS_UPDATE_URL = "/centerprofile/address"
export const CENTER_PROFILE_CONTACT_UPDATE_URL = "/centerprofile/contact"
export const CENTER_PROFILE_CLOSING_UPDATE_URL = "/centerprofile/closing"
export const CENTER_PROFILE_OPEATING_HOUR_UPDATE_URL =
  "/centerprofile/availability"
export const HOUR_TYPE_URL = "/staffhappenings/hourtypes"

//Reports
export const REPORT_URL = "/reports"
export const REPORT_TYPE_URL = "/reports/reporttypes"

//Users
export const CHANGE_PASSWORD_URL = "/users/changepassword"

//THEME
export const THEME_URL = "/themes"
export const UPDATE_THEME = "/themes/updatetheme"

//BASICSETINGS
export const BASICSETINGS_URL = "/themes/getBasicSettings"
export const UPDATE_BASICSETINGS = "/themes/updateBasicSettings"

//CALENDER
//export const GET_EVENTS = "/events"
export const GET_EVENTS = "/childscheduling/getschedules"

export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"

//Wallet
export const WALLET_URL = "/wallet"
export const ADD_WALLET_URL = "/wallet/save"

//Modules
export const ROLETYPE_MODULE_URL = "/module/roletypemodules"

//Impersonation
export const UPDATE_IMPERSONATE_USER = "/users/addimpersonate"
export const DELETE_IMPERSONATE_USER = "/users/removeimpersonate"
export const RESET_USER_PASSWORD_URL = "/users/ResetUserPassword"

//Subscriptions
export const SUBSCRIPTION_URL = "/subscriptions"
export const ADD_NEW_SUBSCRIPTION = "/subscriptions/savesubscription"
export const SUBSCRIPTION_TYPES_URL = "subscriptions/GetSubscriptionTypes"

//Project
export const PROJECT_URL = "/questionnaire/projects"
export const PROJECT_DETAIL_URL = "/questionnaire/projectdetail"
export const ADD_EDIT_PROJECT_URL = "/questionnaire/project"
export const QUESTION_TYPES_URL = "/questionnaire/questiontypes"
export const NNS_NAMES_URL = "/questionnaire/nns"
export const NNS_STRANDS_URL = "/questionnaire/nnsstrands"
export const AWARD_PERIOD_URL = "/questionnaire/periods"
export const QUESTION_DETAIL_URL = "/questionnaire/questiontdetail"
export const QUESTION_RESPONSE_URL = "/questionnaire/save"
export const RESPONSE_OUTCOME_URL = "/questionnaire/response"
export const QUESTION_REPORT_DOWNLOAD_URL = "/questionnaire/downloadexcel"
export const QUESTION_INSTANCE_REPORT_DOWNLOAD_URL =
  "/questionnaire/downloadpdf"

//Household
export const HOUSEHOLD_URL = "/household/households"
export const HOUSEHOLD_DETAIL_URL = "/household/detail"
export const ADD_EDIT_HOUSEHOLD_URL = "/household/household"
export const TRAINING_TYPES_URL = "/household/types"
export const TRAINING_SUBJECTS_URL = "/household/subjects"
export const TRAINING_MONTHS_URL = "/household/months"
export const HOUSEHOLD_FILE_UPLOAD_URL = "/household/uploadfile"
export const HOUSEHOLD_DATA_UPLOAD_URL = "/household/uploaddata"
export const TRAINING_SUBJECT_DETAIL_URL = "/household/subject/detail"
export const TRAINING_SUBJECT_ADD_EDIT_URL = "/household/subject"
